import React from 'react';
import { useTranslation } from 'react-i18next';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { useChain, usePortfolio, useSettings } from 'contexts';
import { formatUsd } from 'utils/number';
import { getChainData } from 'utils/chain';
import { ChainId } from 'utils/types';

const BalanceChart = () => {
  const { t } = useTranslation();
  const {
    color: backupChainColor,
    colorLight: backupChainColorLight,
    colorDark: backupChainColorDark,
  } = getChainData(ChainId.EthMainnet);
  const {
    color: chainColor = backupChainColor,
    colorLight: chainColorLight = backupChainColorLight,
    colorDark: chainColorDark = backupChainColorDark,
  } = useChain();
  const { isDarkMode } = useSettings();
  const {
    walletBalanceTotalUsd,
    whirlpoolBalanceTotalUsd,
    surf3dBalanceTotalUsd,
    beachBalanceTotalUsd,
    polywaveBalanceTotalUsd,
  } = usePortfolio();

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={
        {
          credits: false,
          chart: {
            type: 'column',
            backgroundColor: 'transparent',
          },
          title: {
            text: '',
          },
          tooltip: {
            pointFormatter: function () {
              return formatUsd(this.y || 0);
            },
          },
          plotOptions: {
            column: {
              pointPadding: 0,
              borderWidth: 0,
            },
          },
          xAxis: {
            labels: {
              style: {
                color: isDarkMode ? '#fff' : '#000',
              },
            },
            lineColor: isDarkMode ? '#444' : '#ddd',
            categories: [
              t('portfolio.balance_chart.wallet'),
              t('portfolio.balance_chart.whirlpool'),
              t('portfolio.balance_chart.surf3d'),
              t('portfolio.balance_chart.beach'),
              t('portfolio.balance_chart.polywave'),
            ],
          },
          yAxis: {
            min: 0,
            title: {
              text: '',
            },
            gridLineColor: isDarkMode ? '#444' : '#ddd',
            labels: {
              style: {
                color: isDarkMode ? '#fff' : '#000',
              },
            },
          },
          series: [
            {
              name: t('portfolio.balance'),
              type: 'column',
              data: [
                walletBalanceTotalUsd,
                whirlpoolBalanceTotalUsd,
                surf3dBalanceTotalUsd,
                beachBalanceTotalUsd,
                polywaveBalanceTotalUsd,
              ],
              color: {
                linearGradient: {
                  x1: 0,
                  x2: 0,
                  y1: 0,
                  y2: 1,
                },
                stops: [
                  [0, isDarkMode ? chainColor : chainColor],
                  [1, isDarkMode ? chainColorDark : chainColorLight],
                ],
              },
              showInLegend: false,
            },
          ],
        } as Highcharts.Options
      }
    />
  );
};

export default BalanceChart;
